import { patientIdentityStatusSlugsMap } from '../PatientIdentity/_utils/_utils'
import { PatientIdentityStatusEnum } from '../_props'
import { InsiIdentityStatus2Ids, useGetIdsReferencesInsiidentitystatuses } from '@toktokdoctech/tokapi-client'

export const useGetInsi = (
    insiStatus: PatientIdentityStatusEnum,
): { insi: InsiIdentityStatus2Ids | undefined; isLoading: boolean; error: any } => {
    const { data, isLoading, error } = useGetIdsReferencesInsiidentitystatuses()
    const insi = data?.find((status) => status?.code === patientIdentityStatusSlugsMap[insiStatus])

    return { insi, isLoading, error }
}
